/* eslint-disable */
export const data = {
	title: '¡Conocé los detalles de tu próxima camioneta!',
	list: [
		
		 {
			 poster: {
				 alt: '',
				 sources: [
					 {
						 media: '(max-width: 1024px) and (orientation: portrait)', //smartphone/mobile
						//  srcSet: '/assets/images/main-poster/image-1.jpg',
						 srcSet: '/assets/images/main-poster/image-2-mob.jpg',
					 },
					 {
						 media: '(orientation: landscape)', //smartphone->imagem desk
						//  srcSet: '/assets/images/main-poster/image-1.jpg',
						 srcSet: '/assets/images/main-poster/image-2.jpg',
					 },
					 {
						 media: '(min-width: 1025px)',//desk
						//  srcSet: '/assets/images/main-poster/image-1.jpg',
						 srcSet: '/assets/images/main-poster/image-2.jpg',
					 },
				 ],
			 },
			 thumbnail: '/assets/images/galeria/desk/thumbs/thumb-galeria-1.jpg',
		 },
	  {
	 	 poster: {
	 		 alt: '',
	 		 sources: [
	 		 	 {
	 				 media: '(max-width: 1024px) and (orientation: portrait)', //smartphone/mobile
	 				//  srcSet: '/assets/images/main-poster/image-2.jpg',
	 				 srcSet: '/assets/images/main-poster/image-1-mob.jpg',
	 			 },
	 			 {
	 				 media: '(orientation: landscape)', //smartphone->imagem desk
	 				//  srcSet: '/assets/images/main-poster/image-2.jpg',
	 				 srcSet: '/assets/images/main-poster/image-1.jpg',
	 			 },
	 			 {
	 				 media: '(min-width: 1025px)',//desk
	 				//  srcSet: '/assets/images/main-poster/image-2.jpg',
					 srcSet: '/assets/images/main-poster/image-1.jpg',
				 },
			 ],
		 },
		 thumbnail: '/assets/images/galeria/desk/thumbs/thumb-galeria-2.jpg',
	 },
	 ],
 };

 export default data;
